module.exports = __webpack_public_path__ + "img/menu-deposit-yellow.27bfa0f2.svg";